import { render, staticRenderFns } from "./PleaseLoginExtension.vue?vue&type=template&id=71833d0c"
import script from "./PleaseLoginExtension.vue?vue&type=script&lang=js"
export * from "./PleaseLoginExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports